import { BOOK_COVER_PLACEHOLDER, toAbsoluteUrl } from '../../common/Utils/BookImages';
import { Merchandise } from '../../common/Rest/Services/ShopService';
import { Item, ItemTypeEnum, PriceType } from '../../common/Rest/Services/Data';

export const formatShopPrice = (value: number) => `${Number(value || 0).toFixed(0)} грн`;

export const toShopCartItem = (item: Merchandise): Item => ({
  id: item.id,
  name: item.name,
  type: ItemTypeEnum.Merch,
  stockCount: item.stockCount,
  price: item.price,
  priceType: PriceType.Sale,
  count: 1,
  image: getShopImageUrl(item, 'thumb'),
  description: item.description || undefined,
  isInWishList: false,
});

export const getShopImageUrl = (item: Merchandise, variant: 'thumb' | 'medium' | 'original' = 'medium') => {
  const image = item.primaryImage || item.images?.[0];
  if (!image) return BOOK_COVER_PLACEHOLDER;
  const url = variant === 'thumb' ? image.thumbUrl : variant === 'original' ? image.originalUrl : image.mediumUrl;
  return toAbsoluteUrl(url || image.url) || BOOK_COVER_PLACEHOLDER;
};

// Widths match the variants the API generates (ImageStorage:ThumbMaxWidth / MediumMaxWidth).
export const getShopImageSrcSet = (item: Merchandise) => {
  const image = item.primaryImage || item.images?.[0];
  if (!image) return undefined;
  const sources = [
    [image.thumbUrl, 360],
    [image.mediumUrl, 900],
  ] as const;
  return sources
    .map(([url, width]) => (url ? `${toAbsoluteUrl(url)} ${width}w` : undefined))
    .filter(Boolean)
    .join(', ') || undefined;
};
